module.exports = __webpack_public_path__ + "assets/img/Type BS.5a36ddfe.jpg";